import point from "../point";
import line from "../line";

const Square = (size, isIsland = false) => {
  let points = isIsland ? [
    new point(0, 15, "lefttop"),
    new point(65, 15, "righttop"),
    new point(65, 80, "rightbottom"),
    new point(0, 80, "leftbottom")
  ] : [
    new point(0, 0, "lefttop"),
    new point(65, 0, "righttop"),
    new point(65, 65, "rightbottom"),
    new point(0, 65, "leftbottom")
  ];

  return [
    new line(points[0], points[1]),
    new line(points[1], points[2]),
    new line(points[2], points[3]),
    new line(points[3], points[0])
  ];
};

export default Square
